import { useQuery } from "@tanstack/react-query";
import { clients } from "../../clients";
import { BackendTelemetryClient } from "../../clients/BackendTelemetryClient";
import { Integration } from "../../types";
import { Schemas } from "../../schemas";
import { useAlerts } from "./useAlerts";
import { useMemo } from "react";

export const useAlertsFromIntegration = (integration?: Integration) => {
    const {success, data: systemSchema} = Schemas.systemAlertSchemas.safeParse(integration?.alertSchemaId);
    const {data: alerts} = useAlerts();

    const alertIds = useMemo(() => alerts?.map((a) => a.foreignKeyValue), [alerts]);

    return useQuery({
        queryKey: ["alerts-from-provider", integration?.id],
        enabled: !!integration,
        queryFn: async () => {
            const client = success && systemSchema
                ? clients[systemSchema](integration!)
                : new BackendTelemetryClient(integration!);
            const a = await client.getAlerts();
            return  a.filter(a => !alertIds?.includes(a.id));
        }
    });
};
